import script from "./ExamplePage.vue?vue&type=script&setup=true&lang=js"
export * from "./ExamplePage.vue?vue&type=script&setup=true&lang=js"

import "./ExamplePage.vue?vue&type=style&index=0&id=f574b84e&scoped=true&lang=css"

import exportComponent from "../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f574b84e"]])

export default __exports__